import React from "react";
import { useIntl } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";

const ConsignmentImportHeader = ({ what }) => {
  const intl = useIntl();
  return (
    <TableHeader
      title={intl.formatMessage(
        {
          id: "import",
          defaultMessage: "Import nových {what}",
        },
        { what }
      )}
    />
  );
};

export default ConsignmentImportHeader;
